import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import i18n from "../../constants/i18n";
import ET3Div from "../et3-div";
import { withLiteObserverAndTheme } from "../et3-enhanced-render";
import {
  COLLAPSIBLE_CHEVRON_BOX,
  COLLAPSIBLE_CHEVRON_SIZE,
  COLLAPSIBLE_CLOSED_ROTATION_CSS,
  COLLAPSIBLE_OPEN_ROTATION_CSS,
  COLLAPSIBLE_ROTATION_TRANSITION_CSS
} from "./collapsible-constants";

const CollapsibleChevron = withLiteObserverAndTheme<{ isOpen: boolean }>(
  (props) => {
    const { isOpen, theme } = props;
    const { colors, unitX, unitY } = theme;

    return (
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={COLLAPSIBLE_CHEVRON_BOX}
        height={COLLAPSIBLE_CHEVRON_BOX}
        fDirection="row"
        alignItems="center"
        justifyContent="center"
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <FontAwesomeIcon
          icon={faChevronDown}
          color={colors.all.bondiBlue}
          title={i18n.get(isOpen ? "COLLAPSE_SECTION" : "EXPAND_SECTION")}
          style={{
            width: COLLAPSIBLE_CHEVRON_SIZE * unitX,
            height: COLLAPSIBLE_CHEVRON_SIZE * unitY,
            transition: COLLAPSIBLE_ROTATION_TRANSITION_CSS,
            transform: isOpen
              ? COLLAPSIBLE_OPEN_ROTATION_CSS
              : COLLAPSIBLE_CLOSED_ROTATION_CSS
          }}
        />
      </ET3Div>
    );
  }
);
export default CollapsibleChevron;
